import {
  Injectable,
  signal,
} from '@angular/core';

import { environment } from 'src/environments/environment';

export interface ZeffyPopupContent {
  url: string;
  iframeTitle: string;
  eyebrow: string;
}

@Injectable({
  providedIn: 'root',
})
export class ZeffyPopupService {
  private readonly overlayId = 'popupOverlay';
  private readonly iframeId = 'zeffyDonationFrame';
  private readonly defaultDonationContent: ZeffyPopupContent = {
    url: environment.zeffyDefaultDonationUrl,
    iframeTitle: 'Crezco Foundation Donation',
    eyebrow: 'Main campaign',
  };
  private readonly temporaryCampaignContent: ZeffyPopupContent = {
    url: environment.zeffyPopupDonationUrl,
    iframeTitle: 'New bus for the Hogar de Niños donation form',
    eyebrow: 'Temporary campaign',
  };

  readonly content = signal<ZeffyPopupContent>(
    this.defaultDonationContent
  );

  open(
    content = this.defaultDonationContent
  ): void {
    if (!this.isZeffyEnabled) {
      return;
    }
    this.content.set(content);
    this.content.set(content);

    const popupOverlay =
      document.getElementById(
        this.overlayId
      );

    if (!popupOverlay) {
      return;
    }

    const iframe =
      popupOverlay.querySelector<HTMLIFrameElement>(
        `#${this.iframeId}`
      );

    if (iframe) {
      iframe.setAttribute(
        'src',
        content.url
      );
    }

    popupOverlay.classList.add(
      'active'
    );
  }

  openTemporaryCampaign(): void {
    this.open(
      this.temporaryCampaignContent
    );
  }

  close(
    overlay = document.getElementById(
      this.overlayId
    )
  ): void {
    if (!overlay) {
      return;
    }
    overlay.classList.remove('active');
    overlay.classList.remove('active');

    const iframe =
      overlay.querySelector<HTMLIFrameElement>(
        `#${this.iframeId}`
      );

    iframe?.removeAttribute('src');
  }

  private get isZeffyEnabled(): boolean {
    return environment.donationProvider !== 'custom';
  }
}
